module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "downline"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v(_vm._s(_vm.onlineText) + "列表\n\t\t"), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.list_change
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "position",
      "label": "替换序号",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeName",
      "label": "奖品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('img', {
            staticStyle: {
              "display": "inline-block",
              "width": "150px",
              "margin-top": "5px"
            },
            attrs: {
              "src": _vm.row.imgUrl
            }
          })])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeCount",
      "label": "数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "替换时间",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.replaceStartTime && _vm.row.replaceEndTime) ? _c('div', [_c('div', [_vm._v(_vm._s(_vm.row.replaceStartTime) + " - " + _vm._s(_vm.row.replaceEndTime))])]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "兑换时间",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.startTime && _vm.row.endTime) ? _c('div', [_vm._v(_vm._s(_vm.row.startTime) + " - " + _vm._s(_vm.row.endTime))]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applicableCampus",
      "label": "学校",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近操作记录",
      "align": "center",
      "width": "200"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', [_vm._v(_vm._s(_vm.row.operator))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.operateTime))])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.toDet(_vm.row.id)
              }
            }
          }, [_vm._v("详情")]), _vm._v(" "), (this.online == 0) ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.unPublish(_vm.row)
              }
            }
          }, [_vm._v("下线")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14198596!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/integration/downline.vue
// module id = 948
// module chunks = 0